import { AlertCircle } from 'lucide-react'

export function QueueError({ message, onRetry }: { message: string; onRetry: () => void }) {
  return (
    <div
      role="alert"
      className="mb-2 flex items-center gap-2 rounded-md border border-status-failed/30 bg-status-failed/5 px-3 py-2 text-sm"
    >
      <AlertCircle size={14} className="text-status-failed" />
      <span>Couldn't load alerts.</span>
      <span className="font-mono text-xs text-muted-fg">{message}</span>
      <button
        type="button"
        onClick={onRetry}
        className="ml-auto text-xs text-primary hover:underline"
      >
        Retry
      </button>
    </div>
  )
}
